import { useEffect, useRef } from "react";

type Props = {
  /**
   * Drawing function
   * @param ctx
   */
  draw(ctx: CanvasRenderingContext2D): void;
};

/**
 * Small functional HTML Canvas 2D renderer
 */
export function Canvas(props: Props) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Call the draw function passed in props
    ctx.save();
    props.draw(ctx);
    ctx.restore();
  }, [props.draw]);

  return (
    <canvas
      style={{
        imageRendering: "pixelated",
      }}
      className="absolute top-0 left-0 w-full h-full"
      ref={ref}
    />
  );
}
